<!-- 24猎修改账号密码 -->
<template>
  <div class="user_change">
    <div class="form">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="修改之前用户账号">
          <el-input
            v-model="form.former_username"
            placeholder="请输入修改之前用户账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="修改之后用户账号">
          <el-input
            v-model="form.change_username"
            placeholder="请输入修改之后用户账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="修改之后用户密码">
          <el-input
            v-model="form.company_pwd"
            placeholder="请输入修改之后用户密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="flex">
            <el-button @click="qu_xiao">清空</el-button>
            <el-button type="primary" @click="submit">确认</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      form: {}
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //表单提交
    submit() {
      require("post", "/hr24_user/v1/user_change/", this.form).then(res => {
        if (res.code === 0) {
          this.$message({
            message: res.msg,
            type: "success"
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //表单清空
    qu_xiao() {
      this.form = {};
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
/* //@import url(); 引入公共css类 */
.user_change {
  margin-top: 80px;
  margin-left: 200px;
}
.form {
  width: 50%;
}
.flex {
  margin-right: 20px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/user_management/user_change.vue